import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  Badge,
  Checkbox,
  Select,
  Input,
  Switch,
  Avatar,
  Form,
  Card,
  Modal,
  Divider,
  Button,
  Row,
  Col,
  Icon,
  Dropdown,
  Menu,
  Breadcrumb,
  List,
  Tag,
  Layout,
  Tooltip
} from 'antd';
import XRegExp from 'xregexp';
import styled from 'styled-components';
import VBQLArea from '../Query/VBQLArea';

const sqlSafeNameRegex = XRegExp('^[\\p{L}][\\p{L}\\p{N}_]{0,127}$');
const validateSQLSafeName = (rule, value, callback) => (
  sqlSafeNameRegex.test(value) ? callback() : callback(true)
);

const beginWithLetterRegex = XRegExp('^[\\p{L}]');
const validateBeginWithLetter = (rule, value, callback) => (
  beginWithLetterRegex.test(value) ? callback() : callback(true)
);

const ListItem = styled(List.Item)`
  width: 100%;
  
  .ant-list-item-content {
    width: 100%;
  }
`;

const ListItemMeta = styled(List.Item.Meta)`
  width: 100%;
  
  .ant-list-item-meta-content {
    width: 100%;
    
    .ant-list-item-meta-description {
      overflow-wrap: break-word;
    }
  }
`;

const formItemLayout = {};
const READONLY_STYLES = {
  overflowWrap: 'break-word',
  overflowX: 'hidden',
  width: '100%',
};

class CategoryProps extends React.Component {
  * renderProps() {
    const { mode, form, category = {}, revisions = {}, keys } = this.props;
    const displayWide = mode === 'add';
    const isEditing = mode === 'edit' || mode === 'add';
    const keySet = new Set(keys);

    if (keySet.has('name')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5><label htmlFor="name" className="ant-form-item-required">Name:</label></h5>
                <div style={{ fontSize: '12px' }}>Give your category a unique SQL-safe name.</div>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="name"
                >
                  {
                    form.getFieldDecorator('name', {
                      validateFirst: true,
                      rules: [{
                        required: true,
                        whitespace: false,
                        message: 'Name cannot be left blank',
                      }, {
                        validator: validateBeginWithLetter,
                        message: 'Name must begin with a letter',
                      }, {
                        validator: validateSQLSafeName,
                        message: 'Name may only use letters, numbers, and underscores',
                      }],
                      initialValue: category.name,
                    })(<Input maxLength="128" />)
                  }
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              label="Name"
              key="name"
            >
              {form.getFieldDecorator('name', {
                validateFirst: true,
                rules: [{
                  required: true,
                  whitespace: false,
                  message: 'Name cannot be left blank',
                }, {
                  validator: validateBeginWithLetter,
                  message: 'Name must begin with a letter',
                }, {
                  validator: validateSQLSafeName,
                  message: 'Name may only use letters, numbers, and underscores',
                }],
                initialValue: category.name,
              })(
                <Input maxLength="128" />,
              )}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="name"
          >
            <ListItemMeta
              title={<span>Name</span>}
              description={category.name}
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('published')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={8} style={{ marginTop: '8px' }}>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="published"
                >
                  {form.getFieldDecorator('published', {
                    initialValue: category.published,
                  })(
                    <Switch defaultChecked={category.published} />
                  )}
                  <span style={{ marginLeft: '10px' }}>{!form.getFieldValue('published') && 'Not '}Published</span>
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              key="published"
            >
              {form.getFieldDecorator('published', {
                  initialValue: category.published,
                })(
                  <Switch defaultChecked={category.published} />
              )}
              <span style={{ marginLeft: '10px' }}>{!form.getFieldValue('published') && 'Not '}Published</span>
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="published"
          >
            {category.published ? (<Tooltip title="This category is published so will be applied to new media" ><Avatar
              size="small"
              icon="check"
              shape="square"
              style={{ background: '#8ed752' }}
            /></Tooltip>) : (<Tooltip title="This category is NOT published so will NOT be applied to new media" ><Avatar
              size="small"
              icon="close"
              shape="square"
              style={{ background: '#c3c3c3' }}
            /></Tooltip>)}
            <ListItemMeta
              title={<span style={{ marginLeft: '10px' }}>{!category.published && 'Not '}Published</span>}
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('description')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5>Description:</h5>
                <div style={{ fontSize: '12px' }}>What is the purpose of this category?</div>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="description"
                >
                  {form.getFieldDecorator('description', {
                    initialValue: category.description,
                  })(
                    <Input maxLength="256" />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              label="Description"
              key="description"
            >
              {form.getFieldDecorator('description', {
                initialValue: category.description,
              })(
                <Input maxLength="256" />,
              )}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="description"
          >
            <ListItemMeta
              title={<span>Description</span>}
              description={category.description}
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('tags')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5>Tags:</h5>
                <div style={{ fontSize: '12px' }}>Add tags to help organize your categories.</div>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="tags"
                >
                  {form.getFieldDecorator('tags', {
                    initialValue: category.tags,
                  })(
                    <Select
                      placeholder="Enter a word or phrase and hit return to add a tag."
                      mode="tags"
                      notFoundContent="No tags entered"
                      style={{ width: '100%' }}
                      tokenSeparators={[',']}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              key="tags"
              label="Tags"
            >
              {form.getFieldDecorator('tags', {
                initialValue: category.tags,
              })(
                <Select
                  mode="tags"
                  placeholder="Enter a word or phrase and hit return to add a tag."
                  notFoundContent="No tags entered"
                  style={{ width: '100%' }}
                  tokenSeparators={[',']}
                />,
              )}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="tags"
          >
            <ListItemMeta
              title={<span>Tags</span>}
              description={<span>{R.pathOr([], ['tags'], category).map((tag, i) => <Tag key={i}>{tag}</Tag>)}</span>}
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('query')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5><label htmlFor="query" className="ant-form-item-required">Definition:</label></h5>
                <div style={{ fontSize: '12px' }}>The VBQL query that will be used to match incoming media.</div>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="definition"
                >
                  {form.getFieldDecorator('query', {
                    initialValue: category.query,
                    rules: [{
                      required: true,
                      message: 'You must enter a query definition',
                    }],
                  })(
                    <VBQLArea />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              label="Definition"
              key="definition"
            >
              {form.getFieldDecorator('query', {
                initialValue: category.query,
                rules: [{
                  required: true, message: 'You must enter a query definition',
                }],
              })(
                <VBQLArea />,
              )}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="definition"
          >
            <ListItemMeta
              title={<span>Definition</span>}
              description={<VBQLArea readonly value={category.query} />}
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('version')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5>Version:</h5>
                <div style={{ fontSize: '12px' }}>Give your query a version to help track changes.</div>
              </Col>
              <Col span={16}>
                <Form.Item
                  key="version"
                  {...formItemLayout}
                >
                  {form.getFieldDecorator('version', {
                    initialValue: category.version,
                  })(
                    <Input maxLength="24" />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              key="version"
              {...formItemLayout}
              label="Version"
            >
              {form.getFieldDecorator('version', {
                initialValue: category.version,
              })(
                <Input maxLength="24" />,
              )}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            {...formItemLayout}
            key="version"
          >
            <ListItemMeta
              title={<span>Version</span>}
              description={
                category.version && <Tag color="blue">{category.version}</Tag>
              }
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('notes')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16} style={{ marginBottom: '16px' }}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5>Notes:</h5>
                <div style={{ fontSize: '12px' }}>Enter some notes to help your team.</div>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="notes"
                >
                  {form.getFieldDecorator('notes', {
                    initialValue: category.notes,
                  })(
                    <Input.TextArea name="notes" />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              label="Notes"
              key="notes"
            >
              {form.getFieldDecorator('notes', {
                initialValue: category.notes,
              })(
                <Input.TextArea />,
              )}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="notes"
          >
            <ListItemMeta
              title={<span>Notes</span>}
              description={category.notes}
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('created')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5>Created:</h5>
                <div style={{ fontSize: '12px' }}></div>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="created"
                  label="Created"
                >
                  {category.created}
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              key="created"
              label="Created"
            >
              {category.created}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="created"
          >
            <ListItemMeta
              title="Created"
              description={category.created}
            />
          </ListItem>
        );
      }
    }

    if (keySet.has('lastModified')) {
      if (isEditing) {
        if (displayWide) {
          yield (
            <Row type="flex" gutter={16}>
              <Col span={8} style={{ marginTop: '8px' }}>
                <h5>Modified:</h5>
                <div style={{ fontSize: '12px' }}></div>
              </Col>
              <Col span={16}>
                <Form.Item
                  {...formItemLayout}
                  key="modified"
                  label="Modified"
                >
                  {category.lastModified}
                </Form.Item>
              </Col>
            </Row>
          );
        } else {
          yield (
            <Form.Item
              {...formItemLayout}
              key="modified"
              label="Modified"
            >
              {category.lastModified}
            </Form.Item>
          );
        }
      } else {
        yield (
          <ListItem
            key="modified"
          >
            <ListItemMeta
              title="Modified"
              description={category.lastModified}
            />
          </ListItem>
        );
      }
    }

    /*
    if (isEditing) {
      yield (
        <Form.Item key="__controls" style={{ marginBottom: '0' }}>
          <Row type="flex" justify="end" gutter={16}>
            <Col><Button onClick={this.handleCancel}>Cancel</Button></Col>
            <Col><Button onClick={this.handleDone} type="primary">Apply</Button></Col>
          </Row>
        </Form.Item>
      );
    }
    */
  }

  render() {
    const { mode } = this.props;

    if (mode === 'edit') {
      return (
        <Form>
          {[...this.renderProps()]}
        </Form>
      );
    }

    return (
      <List
        bordered={false}
        split={false}
      >
        {[...this.renderProps()]}
      </List>
    );
  }
}

export default CategoryProps;
